import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxios from "../../utilities/useAxios";
import { logoutFromServer } from "../../utilities/AuthService";
import PageTitle from "../PageTitle";

const ChangeInitialPassword = () => {
	const [oldPassword, setOldPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [newPassword2, setNewPassword2] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState("");

	const navigate = useNavigate();

	const handleSubmit = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		setError("");

		try {
			await useAxios.post("users/change-initial-password/", {
				old_password: oldPassword,
				new_password: newPassword,
				new_password2: newPassword2,
			});
			await logoutFromServer();
			navigate("/login", {
				replace: true,
				state: {
					passwordChangedMessage:
						"비밀번호가 변경되었습니다. 다시 로그인해 주세요.",
				},
			});
		} catch (err) {
			const data = err.response?.data;
			if (typeof data === "object" && data !== null) {
				const parts = [];
				for (const key of Object.keys(data)) {
					const val = data[key];
					if (Array.isArray(val)) {
						parts.push(...val);
					} else if (typeof val === "string") {
						parts.push(val);
					}
				}
				if (parts.length) {
					setError(parts.join(" "));
					return;
				}
			}
			if (err.response?.status >= 500) {
				setError(
					"서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요."
				);
			} else if (err.message === "Network Error") {
				setError("네트워크 연결을 확인해주세요.");
			} else {
				setError(
					"비밀번호 변경에 실패했습니다. 입력 내용을 확인해주세요."
				);
			}
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className="login__container">
			<PageTitle title="비밀번호 변경" />
			<h1 className="login__title">초기 비밀번호 변경</h1>
			<p
				style={{
					textAlign: "center",
					marginBottom: "16px",
					color: "#555",
					fontSize: "14px",
					lineHeight: 1.5,
				}}>
				보안을 위해 새 비밀번호를 설정해 주세요. 변경 후 다시
				로그인합니다.
			</p>
			<form className="login__form" onSubmit={handleSubmit}>
				<input
					type="password"
					value={oldPassword}
					className="login__form__input"
					placeholder="현재 비밀번호"
					onChange={(e) =>
						setOldPassword(e.target.value)
					}
					disabled={isLoading}
					autoComplete="current-password"
				/>
				<input
					type="password"
					value={newPassword}
					className="login__form__input"
					placeholder="새 비밀번호"
					onChange={(e) =>
						setNewPassword(e.target.value)
					}
					disabled={isLoading}
					autoComplete="new-password"
				/>
				<input
					type="password"
					value={newPassword2}
					className="login__form__input"
					placeholder="새 비밀번호 확인"
					onChange={(e) =>
						setNewPassword2(e.target.value)
					}
					disabled={isLoading}
					autoComplete="new-password"
				/>
				{error && (
					<div
						style={{
							color: "red",
							marginBottom: "10px",
							textAlign: "center",
						}}>
						{error}
					</div>
				)}
				<input
					className="login__form__submit"
					type="submit"
					value={
						isLoading
							? "처리 중..."
							: "비밀번호 변경"
					}
					disabled={isLoading}
				/>
			</form>
		</div>
	);
};

export default ChangeInitialPassword;
